import React from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Button, Col, Row, Space, Typography, theme } from "antd";
import { PlusOutlined, ShopOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function StoreHeader({ onCreate }) {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: 24 }}
        items={[
          {
            title: (
              <span
                onClick={() => navigate("/admin")}
                style={{ cursor: "pointer", color: token.colorPrimary }}
              >
                Panel de Administración
              </span>
            ),
          },
          { title: "Gestión de Productos" },
        ]}
      />

      <Row justify="space-between" align="bottom" style={{ marginBottom: 24 }}>
        <Col>
          <Space align="center" size="middle">
            <div
              style={{
                backgroundColor: token.colorPrimary,
                padding: 12,
                borderRadius: token.borderRadiusLG,
                display: "flex",
              }}
            >
              <ShopOutlined style={{ fontSize: 24, color: "#fff" }} />
            </div>
            <div>
              <Title level={2} style={{ margin: 0 }}>
                Tienda Virtual
              </Title>
              <Text type="secondary">
                Administra el catálogo de productos y existencias.
              </Text>
            </div>
          </Space>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            size="large"
            onClick={onCreate}
          >
            Crear Producto
          </Button>
        </Col>
      </Row>
    </>
  );
}
